import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";

type ProfileChoiceDialogContextValue = {
    open: boolean;
    redirectTo?: string;
    openProfileChoice: (redirectTo?: string) => void;
    closeProfileChoice: () => void;
};

const ProfileChoiceDialogContext = createContext<ProfileChoiceDialogContextValue>({
    open: false,
    openProfileChoice: () => {},
    closeProfileChoice: () => {},
});

const Provider: React.FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [redirectTo, setRedirectTo] = useState<string | undefined>();

    const openProfileChoice = useCallback((nextRedirectTo?: string) => {
        setRedirectTo(nextRedirectTo);
        setOpen(true);
    }, []);

    const closeProfileChoice = useCallback(() => {
        setOpen(false);
        setRedirectTo(undefined);
    }, []);

    return (
        <ProfileChoiceDialogContext.Provider
            value={{ open, redirectTo, openProfileChoice, closeProfileChoice }}
        >
            {children}
        </ProfileChoiceDialogContext.Provider>
    );
};

const useProfileChoiceDialog = () => useContext(ProfileChoiceDialogContext);

export { ProfileChoiceDialogContext as Context, Provider, useProfileChoiceDialog };
